export default __webpack_public_path__ + "static/avatar-barbara-johnson2-a765d96a295a873a6825351effe80665.jpg";